import Template from '@/modules/template/router';
import SaasSystemManage from '@/modules/saas-system-manage/router';
import InspirationTaskManage from '@/modules/inspiration-task-manage/router';
import PhotoCenter from '@/modules/photo-center/router';
import AigcAdmin from '@/modules/aigc-admin/router';
import DigitalPrinting from '@/modules/digital-printing/router';

export default [
  ...Template,
  ...SaasSystemManage,
  ...InspirationTaskManage,
  ...PhotoCenter,
  ...AigcAdmin,
  ...DigitalPrinting,
];
